// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"0664c8fb","81":"8afc600b","84":"b93149a2","95":"66169a73","113":"1430cb79","177":"50d27305","233":"0f52994b","261":"c1eabf2d","278":"ddef7507","453":"6dfbd809","590":"726a21f2","601":"b5b856dc","773":"367b5cb5","813":"16e548d6","834":"da44ac7e","848":"471c8607"}[chunkId] + ".chunk.js";
};